import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MyHospitalUsersComponent } from './my-hospital-users.component';
import { CreateUserComponent } from './create-user/create-user.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { ViewUserComponent } from './view-user/view-user.component';
import { SharedModule } from '../shared/shared.module';
import { SitePermissionEditorV2Component } from '@app/shared/site-permission-editor-v2/site-permission-editor-v2.component';

@NgModule({
    declarations: [
        MyHospitalUsersComponent,
        CreateUserComponent,
        ViewUserComponent
    ],
    imports: [
        CommonModule,
        MatAutocompleteModule,
        SharedModule,
        SitePermissionEditorV2Component
    ],
    exports: [MyHospitalUsersComponent],
    providers: []
})
export class MyHospitalUsersModule {}
